import React from 'react'
import PropTypes from 'prop-types'
import * as styles from './_AdviserProfileFinancialServicesOffered.scss'
import withStyles from 'isomorphic-style-loader/withStyles'

class AdviserProfileFinancialServicesOffered extends React.Component {

  static propTypes = {
    financialServices: PropTypes.array
  }
  static defaultProps = {
    financialServices: []
  }

  render () {
    const services = this.props.financialServices || []

    return (
      <div>
        <h4 className={styles['headings']}>Services offered</h4>
        <ul>
          {services.length === 0 ? (
            <li>No services listed</li>
          ) : (
            services.map(service => (
              <li key={service.id || service.name}>{service.name}</li>
            ))
          )}
        </ul>
      </div>
    )
  }
}

export default withStyles(styles)(AdviserProfileFinancialServicesOffered)
